import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConnectionService } from 'src/app/services/connection/connection.service';
import { LocalizationService } from 'src/app/services/localization.service';
import { PartnerRegistrationConfiguration } from '../models/partner-registration-configuration';

@Injectable()
export class PartnerRegistrationService {

  constructor(
    private connectionService: ConnectionService,
    private localizationService: LocalizationService
  ) {
  }

  getRegistrationConfiguration(): Observable<PartnerRegistrationConfiguration> {
    return this.connectionService.sendJsonPostRequest('/store/partner/kiosk-registration-configuration', { })
    .pipe(
      map( data => PartnerRegistrationConfiguration.createFromAny(data)),
    );
  }

  getConfirmationText(): Observable<string> {
    return this.connectionService.sendJsonPostRequest('/store/partner/confirmation-text', { lang: this.localizationService.currentLang});
  }

  acceptAgreement(): Observable<boolean> {
    return this.connectionService.sendJsonPostRequest('/store/partner/accept-agreement', { });
  }

}
